import apiConfig from "../../config/apiConfig"
import { END_POINT } from "../../store/constants"
import { store } from '../../store';
import apiConfigWthFormData from "../../config/apiConfigWthFormData";
import { UPLOAD_MAX_FILE_SIZE } from "../../config/config";

export const uploadImage = (file) => {
   const formData = new FormData();
   if (file.size > UPLOAD_MAX_FILE_SIZE) {
      return Promise.reject(new Error(("File không vượt quá 5MB!")));
   }
   formData.append('file', file);
   return apiConfig.post(END_POINT.UPLOAD_MEDIA, formData);
}

export const fbAttachment = (url) => {
   const page = store.getState().page;
   const params = {
      url: url,
      fb_page_id: page.social_id
   }
   return apiConfigWthFormData.post(END_POINT.FB_ATTACHMENT, params);
}